<template>
  <form
    @submit.prevent="onSave">

    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onViewJob"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to').toUpperCase()}}  {{$t('job.singular').toUpperCase()}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-8">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('job.form.information')}}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <DropDown 
                    class="col-md-4"
                    :placeholder="$t('job.form.company.placeholder')"
                    :label="$t('job.form.company.label')"
                    :name.sync="model.company_id"
                    :options="companies" 
                    v-model="model.company_id"
                    @change="onCompanyChange"
                  />
                </div>
              </div>
              <TextField 
                :placeholder="$t('job.form.title.placeholder')"
                :label="$t('job.form.title.label')"
                v-model="model.title"
                :error="$v.model.title.$error"
                :errorMessage="$v.model.title.errorMessage"
                class="col-md-4"
              />
              <TextField 
                :placeholder="$t('job.form.city.placeholder')"
                :label="$t('job.form.city.label')"
                v-model="model.city"
                :error="$v.model.city.$error"
                :errorMessage="$v.model.city.errorMessage"
                class="col-md-4"
              />
              <TextField 
                :placeholder="$t('job.form.country.placeholder')"
                :label="$t('job.form.country.label')"
                v-model="model.country"
                :error="$v.model.country.$error"
                :errorMessage="$v.model.country.errorMessage"
                class="col-md-4"
              />

              <DropDown 
                class="col-md-4"
                :placeholder="$t('job.form.employment_type.placeholder')"
                :label="$t('job.form.employment_type.label')"
                :name.sync="model.employment_type"
                v-model="model.employment_type"
                :options="employment_type_options" 
                :error="$v.model.employment_type.$error"
                :errorMessage="$v.model.employment_type.errorMessage"
              />

              <DropDown 
                class="col-md-4"
                :placeholder="$t('job.form.level.placeholder')"
                :label="$t('job.form.level.label')"
                :name.sync="model.level"
                v-model="model.level"
                :options="levels" 
              />

              <TextField 
                :placeholder="$t('job.form.slots.placeholder')"
                :label="$t('job.form.slots.label')"
                v-model="model.slots"
                type="number"
                :error="$v.model.slots.$error"
                :errorMessage="$v.model.slots.errorMessage"
                class="col-md-4"
              />
              <!-- <DropDown 
                class="col-md-4"
                placeholder="Select an Industry"
                label="Company Industry"
                :name.sync="model.industry_id"
                v-model="model.industry_id"
                :options="industry_options" 
                :error="$v.model.industry_id.$error"
                :errorMessage="$v.model.industry_id.errorMessage"
              /> -->
              <div class="form-group col-md-12">
                <label for="" class="form-label">{{$t('job.form.industry.label')}}</label>
                 <multiselect
                  v-model="model.industry_id"
                  :options="industry_options"
                  :searchable="true"
                  :multiple="true"
                  :placeholder="$t('job.form.industry.placeholder')"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :show-labels="false"

                  track-by="_id"
                  label="name"
                ></multiselect>
              </div>

              <div class="form-group col-md-12">
                <label for="" class="form-label">{{$t('job.form.function.label')}}</label>
                 <multiselect
                  v-model="model.function_id"
                  :options="function_options"
                  :searchable="true"
                  :multiple="true"
                  :placeholder="$t('job.form.function.placeholder')"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :show-labels="false"

                  track-by="_id"
                  label="name"
                ></multiselect>
              </div>
             
              <!-- <DropDown 
                class="col-md-4"
                placeholder="Select a Function"
                label="Function"
                :name.sync="model.function_id"
                v-model="model.function_id"
                :options="function_options" 
                :error="$v.model.function_id.$error"
                :errorMessage="$v.model.function_id.errorMessage"
              /> -->
              
              <div class="form-group col-12">
                <label for="">{{$t('job.form.summary.label')}}</label>
                  <vue-editor 
                  height="250"
                  :placeholder="$t('job.form.summary.placeholder')"
                  v-model="model.summary"></vue-editor>
              </div>

              <div class="col-12">
                <label for="">{{$t('job.form.full_details.label')}}</label>
                <vue-editor 
                  height="400"
                  :placeholder="$t('job.form.full_details.placeholder')"
                  v-model="model.description">
                </vue-editor>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('job.form.financing')}}</h4>
            <p class="sub-header"></p>
            <div class="row border-bottom mb-3">
              <!-- <TextField 
                placeholder="xxx,xxx"
                label="Min Salary"
                type="number"
                class="col-md-6"
                v-model="model.min_salary"
              /> -->
              <DropDown 
                class="col-md-6"
                :placeholder="$t('job.form.currency.placeholder')"
                :label="$t('job.form.currency.label')"
                :name.sync="model.currency_id"
                v-model="model.currency_id"
                :options="currency_options" 
                :error="$v.model.currency_id.$error"
                :errorMessage="$v.model.currency_id.errorMessage"
              />
              <div class="row col-md-12">
                <div class="form-group col-md-12">
                  <b-form-checkbox 
                    v-model="model.use_min_max_salary" 
                    name="check-button" 
                    switch
                    @change="onBlur"
                    >
                    Min and Max Salary
                  </b-form-checkbox>
                </div>
                <div class="form-group col-md-6" v-if="model.use_min_max_salary">
                  <label for="" class="form-label">{{$t('job.form.min_salary.label')}}</label>
                  <currency-input
                    class="form-control"
                    placeholder="xxx,xxx"
                    v-model="model.min_salary"
                    :precision="genPrecision"
                  />
                </div>

                <div class="form-group col-md-6" v-if="model.use_min_max_salary">
                  <label for="" class="form-label">{{$t('job.form.max_salary.label')}}</label>
                  <currency-input
                    class="form-control"
                    placeholder="xxx,xxx"
                    v-model="model.max_salary"
                    :precision="genPrecision"
                  />
                </div>
                  <TextField 
                    placeholder="Salary"
                    label="Salary"
                    v-model="model.salary"
                    class="col-md-6"
                    v-if="!model.use_min_max_salary"
                  />
              </div>

            </div>

            <h4 class="header-title mt-0 mb-3">{{$t('job.form.commission_setup')}}</h4>
            <div class="form-group">
              <b-form-checkbox 
                v-model="model.fixed" 
                name="check-button" 
                switch
                @change="onBlur"
                >
                {{$t('job.form.use_fixed_rate')}}
              </b-form-checkbox>
            </div>
            <div class="row">
              <TextField 
                :max="model.fixed ? 0 : 100"
                :placeholder="model.fixed ? 'xx,xxx' : '%'"
                :label="$t('job.form.commission_rate.label')"
                type="number"
                class="col-md-6"
                v-model="model.rate"
              />
            </div>

          </div>
        </div>
      </div>
      <!-- end col -->
    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'


export default {
  mixins: [FormMixin],
  components:{FixedHeader, TextField, DropDown, VueEditor, Multiselect},
  data(){
    return {
      model:{
        company_id:'',
        title:'',
        city:'',
        country:'',
        employment_type:'',
        industry:'',
        level:'',
        suummary:null,
        description:null,
        min_salary:null,
        max_salary:null,
        rate:null,
        industry_id:'',
        function_id:'',
        currency_id:'',
        slots:0,
        fixed:false
      },
      companies: [],
      employment_type_options: [
        { value: null, text: '-' },
        { value: 'full-time', text: 'Full-time' },
        { value: 'part-time', text: 'Part-time' },
        { value: 'self-employed', text: 'Self-employed' },
        { value: 'freelance', text: 'Freelance' },
        { value: 'contract', text: 'Contract' },
        { value: 'intership', text: 'Internship' }
      ],
      levels:[
        {value:'Internship', text:'Internship'},
        {value:'Entry Level', text:'Entry Level'},
        {value:'Associate', text:'Associate'},
        {value:'Mid-Senior Level', text:'Mid-Senior Level'},
        {value:'Director', text:'Director'},
        {value:'Excecutive', text:'Excecutive'},
        {value:'Others', text:'Others'}
      ],
      industry_options: [],
      function_options: [],
      currency_options:[],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
    }
  },
  validations: {
    model:{
      title: { required },
      country: { required },
      city: { required },
      company_id: { required },
      industry_id: { required },
      employment_type: { required },
      currency_id: { required },
      slots: { required },
    }
  },
  computed:{
    genPrecision(){
      let currentCurrency = this.currency_options.filter(el => {return el.symbol == '¥' && this.model.currency_id == el.value})

      return currentCurrency.length ? 0 : 2
    }
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('job', ['create', 'find', 'update']),
    ...mapActions('company', {'companyAll':'all'}),
    ...mapActions('company', {'findCompany':'find'}),
    ...mapActions('function', {'functionAll':'all'}),
    ...mapActions('industry', {'industryAll':'all'}),
    ...mapActions('currency', {'currencyAll':'all'}),
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    onSave() {
      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}

      this[!this.model.id ? 'create' : 'update'](this.model).then(res => {
        this.toggleLoading()
        this.$router.push('/job/view?id=' + res.data.job._id)
      })
      .catch((err) => {
        this.toggleLoading()
        console.log(err)
        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/job')
    },
    onViewJob() {
      var id = this.$route.query.id
      this.$router.push('/job' + (id ? '/view?id=' + this.$route.query.id : ''))
    },
    onCompanyChange(val) {
      this.findCompany({
        id:val
      }).then(data => {
        var _data = data.data
        this.model.fixed = _data.fixed
        this.model.rate = _data.rate.$numberDecimal
        this.model.industry_id = _data.industry_id
        this.model.function_id = _data.function_id
      })
    }
  },
 async beforeMount() {
    await this.companyAll().then(data => {
      data.data.forEach(el => {
        this.companies.push({
          text:el.name,
          value:el._id
        }) 
      })
    })

    await this.industryAll().then(data => {
      data.data.forEach(el => {
        this.industry_options.push(el) 
      })
    })

    await this.functionAll().then(data => {
      data.data.forEach(el => {
        this.function_options.push(el) 
      })
    })

    await this.currencyAll().then(data => {
      data.data.forEach(el => {
        this.currency_options.push({
          text:el.code,
          symbol:el.symbol,
          value:el._id
        }) 
      })
    })

    let id = this.$route.query.id
    if(id){
      this.find({
        id:id
      }).then(data => {
        this.model = data.data
        this.model.min_salary = data.data.min_salary ? parseFloat(data.data.min_salary.$numberDecimal) : 0
        this.model.max_salary = data.data.max_salary ? parseFloat(data.data.max_salary.$numberDecimal) : 0
        this.model.rate = data.data.rate ? data.data.rate.$numberDecimal : 0
        this.model.id = data.data._id
        this.model.company_id =  this.model.company_id._id
        this.model.currency_id =  this.model.currency_id._id
      })
    }
  },
  /* watch:{
    'model.rate':{
      handler: function() {
        if(this.model.rate > 100){
          this.model.rate = 100
        }
      }
    }
  } */
}
</script>

